import { API_HOST, getHttpGetOptions, getHttpPostOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/contract`;

const getViewPersonContractsEndpoint = () => `${getEndpoint()}/view`;
export const getViewPersonContractsRequest = () => [
  getViewPersonContractsEndpoint(),
  getHttpGetOptions({
    currency_code: 'USD',
  }),
];

const getViewContractEndpoint = (contractExternalReference) => `${getEndpoint()}/retrieve/${contractExternalReference}`;
export const getViewContractRequest = (contractExternalReference) => [
  getViewContractEndpoint(contractExternalReference),
  getHttpGetOptions({
    currency_code: 'USD',
  }),
];

const getExpressInterestEndpoint = (productExternalReference) =>
  `${getEndpoint()}/express-interest/${productExternalReference}`;
export const getExpressInterestRequest = (productExternalReference) => [
  getExpressInterestEndpoint(productExternalReference),
  getHttpGetOptions({
    currency_code: 'USD',
  }),
];

const getAmendContractEndpoint = () => `${getEndpoint()}/amend`;
export const getAmendContractRequest = (contract) => [
  getAmendContractEndpoint(),
  getHttpPostOptions(contract, {
    currency_code: 'USD',
  }),
];

const getUpdateContractStatusEndpoint = (dealNumber, status) =>
  `${getEndpoint()}/update/status/${dealNumber}/${status}`;
export const getUpdateContractStatusRequest = (dealNumber, status) => [
  getUpdateContractStatusEndpoint(dealNumber, status),
  getHttpPutOptions(undefined, {
    currency_code: 'USD',
  }),
];

const getCancelContractEndpoint = (dealNumber) => `${getEndpoint()}/cancel/${dealNumber}`;
export const getCancelContractRequest = (dealNumber) => [
  getCancelContractEndpoint(dealNumber),
  getHttpPutOptions(undefined, {
    currency_code: 'USD',
  }),
];

const getRetrieveChatForDealEndpoint = (dealNumber, personExternalReference) =>
  `${getEndpoint()}/retrieve/chat/${dealNumber}/${personExternalReference}`;
export const getRetrieveChatForDealRequest = (dealNumber, personExternalReference) => [
  getRetrieveChatForDealEndpoint(dealNumber, personExternalReference),
  getHttpGetOptions({
    currency_code: 'USD',
  }),
];

const getCreateMessageForDealEndpoint = () => `${getEndpoint()}/create/message`;
export const getCreateMessageForDealRequest = (message) => [
  getCreateMessageForDealEndpoint(),
  getHttpPostOptions(message, {
    currency_code: 'USD',
  }),
];

const getViewAdminContractsEndpoint = () => `${getEndpoint()}/admin/retrieve-all-contracts`;
export const getViewAdminContractsRequest = (filters) => [
  getViewAdminContractsEndpoint(),
  getHttpPostOptions(filters, {
    currency_code: 'USD',
  }),
];

const getRequestAssistanceEndpoint = () => `${getEndpoint()}/request-assistance`;
export const getRequestAssistanceRequest = (data) => [
  getRequestAssistanceEndpoint(),
  getHttpPostOptions(data, {
    currency_code: 'USD',
  }),
];

const getReviewDocumentEndpoint = () => `${getEndpoint()}/admin/review-document`;
export const getReviewDocumentRequest = (document) => [
  getReviewDocumentEndpoint(),
  getHttpPostOptions(document, {
    currency_code: 'USD',
  }),
];
